import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [RouterLink, RouterLinkActive, IconModule, TranslateModule],
  selector: 'kr-sidebar-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrl: './nav-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent {
  link = input<string | string[]>();
  iconName = input<string>();
  i18nKey = input<string>();
  exactRoute = input(false, { transform: booleanAttribute });

  get activeOptions(): { exact: boolean } | IsActiveMatchOptions {
    return this.exactRoute()
      ? {
          paths: 'exact',
          matrixParams: 'exact',
          queryParams: 'ignored',
          fragment: 'ignored',
        }
      : { exact: false };
  }
}
